import { Card } from '@cortex/web-design-system/components/ui/Card';

/**
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business バグ評価詳細ページのローディングスケルトン。ヘッダー / スコアカード / 評価詳細 / レビューの構造を pulse 背景で示す。
 * @graph-connects none
 */
export function LoadingSkeleton() {
  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex items-center justify-between">
        <div>
          <div className="h-7 w-32 rounded bg-[var(--color-bg-elevated)] animate-pulse" />
          <div className="h-4 w-48 mt-2 rounded bg-[var(--color-bg-elevated)] animate-pulse" />
        </div>
        <div className="h-4 w-24 rounded bg-[var(--color-bg-elevated)] animate-pulse" />
      </div>
      <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
        {[1, 2, 3, 4].map((i) => (
          <Card key={i} className="p-4 text-center">
            <div className="h-3 w-12 mx-auto rounded bg-[var(--color-bg-elevated)] animate-pulse" />
            <div className="h-8 w-10 mx-auto mt-2 rounded bg-[var(--color-bg-elevated)] animate-pulse" />
          </Card>
        ))}
      </div>
      <Card className="p-6">
        <div className="h-5 w-20 rounded bg-[var(--color-bg-elevated)] animate-pulse mb-4" />
        <div className="grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((i) => (
            <div
              key={i}
              className="h-4 w-3/4 rounded bg-[var(--color-bg-elevated)] animate-pulse"
            />
          ))}
        </div>
        <div className="mt-4">
          <div className="h-4 w-16 rounded bg-[var(--color-bg-elevated)] animate-pulse mb-2" />
          <div className="h-24 rounded-lg bg-[var(--color-bg-elevated)] animate-pulse" />
        </div>
      </Card>
      <Card className="p-6">
        <div className="h-5 w-16 rounded bg-[var(--color-bg-elevated)] animate-pulse mb-4" />
        <div className="h-4 w-2/3 rounded bg-[var(--color-bg-elevated)] animate-pulse" />
      </Card>
    </div>
  );
}
